<template>
  <div class="comment-course">
    <Form ref="searchForm" inline :label-width="70">
      <Form-item label="星级">
        <Select placeholder="全部" v-model="searchCondition.grade" style="width:200px" clearable>
          <Option v-for="item in statusList" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
      </Form-item>
      <Form-item :label-width="100">
        <Input
          style="width:240px"
          placeholder="请输入评论内容关键字"
          v-model="searchCondition.content"
          clearable
          @keydown.native.prevent.enter="seach(0)"
        ></Input>
      </Form-item>
      <Form-item :label-width="20">
        <Input
          style="width:240px"
          placeholder="请输入图书名称关键字"
          v-model="searchCondition.book"
          clearable
          @keydown.native.prevent.enter="seach(0)"
        ></Input>
      </Form-item>
      <Form-item class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="seach(0)">搜索</Button>
          <Button icon="md-undo" @click="seach(1)">重置</Button>
        </div>
      </Form-item>
    </Form>
    <comment
      ref="comment"
      data-url="/api/books/comment/list"
      :search="searchCondition"
      :deleteHandler="deleteHandler"
    ></comment>
  </div>
</template>

<script>
import comment from "../../../components/Comment";
export default {
  name: "",
  components: {
    comment
  },
  data() {
    return {
      searchCondition: {
        grade: "",
        book: "",
        content: ""
      },
      statusList: [
        { id: 1, name: "一星" },
        { id: 2, name: "二星" },
        { id: 3, name: "三星" },
        { id: 4, name: "四星" },
        { id: 5, name: "五星" }
      ]
    };
  },
  methods: {
    seach(flag) {
      // 重置
      if (flag) {
        this.searchCondition.grade = "";
        this.searchCondition.book = "";
        this.searchCondition.content = "";
      }
      this.$refs.comment.searchRefresh();
    },
    async deleteHandler(id) {
      await this.$http.delete("/api/books/comment/" + id);
      this.$refs.comment.searchRefresh();
    }
  }
};
</script>

<style scoped>
</style>
